export enum Routes {
  accountManagementBlockedPage = '/account-management-blocked',
  cards = '/cards',
  checkout = 'checkout',
  // TODO: useless route, remove itw
  content = '/content',
  // END
  deposit = 'deposit',
  depositDisplayForm = '/deposit/deposit-display-form',
  depositError = '/deposit/deposit-error',
  depositMethod = 'deposit/:provider/',
  depositMethodForm = 'deposit/:provider/:form',
  depositProcessing = '/deposit/deposit-processing',
  depositSuccess = '/deposit/deposit-success',
  depositAwait = '/deposit/deposit-await',
  withdrawal = 'withdrawal',
  withdrawalMethod = 'withdrawal/:provider/',
  withdrawalCardList = '/withdrawal-cards',
  withdrawalVerifyAccount = '/withdrawal-verify-account',
  withdrawalProcessing = '/withdrawal/withdrawal-processing',
  withdrawalSuccess = '/withdrawal/withdrawal-success',
  withdrawalError = '/withdrawal/withdrawal-error',
  page3dsResult = '/3ds_result',
  pageLLA = '/payments/interaction/:provider',
  pageLLAStatus = '/payments/status/:provider',
  page3dsStatus = '/payments/3ds_result/:provider',
  betshopDeposit = '/betshop-deposit',
  betshopWithdrawal = '/betshop-withdrawal',
  rejectWithdrawal = '/reject-withdrawal',
  selectCountry = '/select-country',
  selectCurrency = '/select-currency',
  selectNetwork = '/select-network',
  cascading = '/cascading',
  selectBonuses = '/select-bonus',
  bonusDescription = '/bonus-description',
}
